module.exports = __webpack_public_path__ + "img/6.c8297170.jpg";